<template>
	<app-modal
		@close="close"
	>
		<app-modal-default @close="close">
			<template v-slot:header>
				{{ $ml.get(`Unsubscription`) }}
			</template>
			<template v-slot:content>
				<div class="feedback">
					<answer v-if="feedback == 'ansver'" @to-pause="toPause" @to-feedback="feedback = 'feed'" />
					<content-feedback @setFeedback="saveFeed" v-else-if="feedback == 'feed'" />
					<exit-feed v-else />
				</div>
			</template>
		</app-modal-default>
	</app-modal>
	
</template>

<script>
import { PlansAPI } from '@/api';
import Answer from './Answer'
import ContentFeedback from './ContentFeedback'
import ExitFeed from './Exit'

export default {
	data () {
		return {
			feedback: 'ansver',
		}
	},
	components: {
		Answer,
		ContentFeedback,
		ExitFeed
	},
	methods: {
		saveFeed () {
			this.feedback = 'exit';
		},

		toPause() {
			this.$emit('close');
			this.$emit('open-pause');
		},

		close() {
			this.$emit('close');
		},
	}
}
</script>

<style lang="scss" scoped>

</style>